{{#if this.isValid}}
  {{i18n this.validMessageKey}}
{{else}}
  {{i18n this.invalidMessageKey}}
{{/if}}